
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import PicPay from './pages/PicPay';
import Parceiros from './pages/Parceiros';
import VrBeneficios from './pages/VrBeneficios';
import Azul from './pages/Azul';
import ClickBus from './pages/ClickBus';
import ValeBonus from './pages/ValeBonus';
import Vitalicio from './pages/Vitalicio';
import GrupoWpp from './pages/GrupoWpp';

function SubdomainRedirect() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const hostname = window.location.hostname;
    
    // Redireciona subdomínio vitalicio para /vitalicio se estiver na raiz
    if (hostname === 'vitalicio.ewpass.com.br' && location.pathname === '/') {
      navigate('/vitalicio', { replace: true });
    }
  }, [navigate, location]);

  return null;
}

function App() {
  return (
    <Router>
      <div className="App">
        <SubdomainRedirect />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/picpay" element={<PicPay />} />
          <Route path="/parceiros" element={<Parceiros />} />
          <Route path="/vrbeneficios" element={<VrBeneficios />} />
          <Route path="/azul" element={<Azul />} />
          <Route path="/clickbus" element={<ClickBus />} />
          <Route path="/valebonus" element={<ValeBonus />} />
          <Route path="/vitalicio" element={<Vitalicio />} />
          <Route path="/grupowpp" element={<GrupoWpp />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
